// CONTEXT codes (each maps to a backend-side filter):
//   CPBBC — Catalog Pre-Bid, Bid, & Contract
//   CMME  — Catalog Make-Model Edit

export const createMakeModelApi = (context) => {
  const makesFetchOptionsPromise = (searchValue, token, signal) =>
    fetch(window.AFP_CONFIG.api_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        query: `
          query GetMakesByPartialMatch(
            $makeName: String!
            $context: String
          ) {
            getMakesByPartialMatch(
              makeName: $makeName
              context: $context
            ) {
              value: makeCode
              label: makeName
              nhtsaMakeCode
              nhtsaStatus
              fleetStatus
            }
          }
        `,
        variables: {
          makeName: searchValue,
          context,
        },
      }),
      signal,
    });

  const modelsFetchOptionsPromise = (inputValue, makeCode, token, signal) =>
    fetch(window.AFP_CONFIG.api_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        query: `
          query GetModelsByPartialMatch(
            $makeCode: Int!
            $modelName: String!
            $context: String
          ) {
            getModelsByPartialMatch(
              makeCode: $makeCode
              modelName: $modelName
              context: $context
            ) {
              value: modelCode
              label: modelName
              nhtsaModelCode
              nhtsaStatus
              fleetStatus
            }
          }
        `,
        variables: {
          modelName: inputValue,
          makeCode: makeCode ? Number.parseInt(makeCode, 10) : -1,
          context,
        },
      }),
      signal,
    });

  return { makesFetchOptionsPromise, modelsFetchOptionsPromise };
};

// CPBBC-bound helpers — imported by the pre-bid, bid, and contract providers.
// For other contexts (e.g., make-model-edit), call createMakeModelApi('CMME').
export const { makesFetchOptionsPromise, modelsFetchOptionsPromise } =
  createMakeModelApi('CPBBC');
